import { useContext } from "react";
import { TopBarPathnameContext, TopBarCurrentValueContext, TopBarTabsArrayContext } from "../context/TopBarProvider";

export const useTopBarCurrentValue = () => useContext(TopBarCurrentValueContext);
export const useTopBarTabsArray = () => useContext(TopBarTabsArrayContext);
export const useTopBarPathname = () => useContext(TopBarPathnameContext);
